import React, { useState, useEffect } from 'react';
import { StyleSheet, Text, View, TouchableOpacity } from 'react-native';
import DeviceSettings from '../../DeviceSettings/DeviceSettings';
import { Icon, Iffy, luxColors, Popover, } from '@alucio/lux-ui';
import { MeetingInfoDialog } from './DialogMenu';
import { SideBarOption } from './Menu';
import { MODE_TYPE, useMeetingControls } from '@alucio/video';
const styles = StyleSheet.create({
    settingsMenuContainer: {
        flex: 1,
        flexDirection: 'column',
        alignSelf: 'flex-start',
        borderRadius: 4,
        borderWidth: 2,
        paddingBottom: 17,
        paddingLeft: 20,
        paddingRight: 20,
        borderColor: luxColors.contentPanelBackground.tertiary,
        backgroundColor: luxColors.contentPanelBackground.primary,
        width: 220,
    },
    settingsMenuOption: {
        flex: 1,
        flexDirection: 'row',
        marginTop: 17,
    },
    settingsMenuIcon: {
        width: 17,
        height: 17,
        color: luxColors.info.primary,
    },
    settingsMenuLabel: {
        color: luxColors.info.primary,
        fontSize: 16,
        marginLeft: 10,
    },
});
export function SettingsMenuContent(props) {
    const { settingsParams, isHeaderHidden, onCloseSettings } = props;
    const { audioFiles, localPhoneAudio, togglePhoneAudio } = settingsParams;
    const [settingsMenuToggle, setSettingsMenuToggle] = useState({ visible: true, mode: '' });
    const { mode } = useMeetingControls();
    useEffect(() => {
        setSettingsMenuToggle(toggled => (isHeaderHidden && toggled) ? { visible: false } : toggled);
    }, [isHeaderHidden]);
    const handleAudioToggle = () => {
        togglePhoneAudio();
        onCloseSettings();
    };
    return (React.createElement(View, null,
        React.createElement(Iffy, { is: settingsMenuToggle.visible },
            React.createElement(View, { style: styles.settingsMenuContainer },
                React.createElement(TouchableOpacity, { onPress: () => setSettingsMenuToggle({ visible: false, mode: 'settings' }) },
                    React.createElement(View, { style: styles.settingsMenuOption },
                        React.createElement(Icon, { style: styles.settingsMenuIcon, name: "cog" }),
                        React.createElement(Text, { style: styles.settingsMenuLabel }, "Device Settings"))),
                React.createElement(TouchableOpacity, { onPress: handleAudioToggle },
                    React.createElement(View, { style: styles.settingsMenuOption },
                        React.createElement(Icon, { style: styles.settingsMenuIcon, name: localPhoneAudio ? 'volume-high' : 'phone' }),
                        React.createElement(Text, { style: styles.settingsMenuLabel }, localPhoneAudio ? 'Use Computer for Audio' : 'Use Phone for Audio'))),
                React.createElement(Iffy, { is: mode === MODE_TYPE.HOST },
                    React.createElement(TouchableOpacity, { onPress: () => setSettingsMenuToggle({ visible: false, mode: 'info' }) },
                        React.createElement(View, { style: styles.settingsMenuOption },
                            React.createElement(Icon, { style: styles.settingsMenuIcon, name: "information-outline" }),
                            React.createElement(Text, { style: styles.settingsMenuLabel }, "Meeting info")))))),
        React.createElement(Iffy, { is: !settingsMenuToggle.visible && settingsMenuToggle.mode === 'settings' },
            React.createElement(DeviceSettings, { disableLocalAudio: localPhoneAudio, onDone: onCloseSettings, audioFiles: audioFiles !== null && audioFiles !== void 0 ? audioFiles : [] })),
        React.createElement(Iffy, { is: !settingsMenuToggle.visible && settingsMenuToggle.mode === 'info' },
            React.createElement(MeetingInfoDialog, { onClose: onCloseSettings }))));
}
export const SettingsMenu = (props) => {
    const { menuOption, isHeaderHidden } = props;
    const [settingsToggle, setSettingsToggle] = useState(false);
    const { isFullScreen } = useMeetingControls();
    return (React.createElement(Popover, { key: menuOption.title, lazyMount: true, interactive: true, placement: "bottom-start", visible: settingsToggle, type: "menu" },
        React.createElement(Popover.Anchor, null,
            React.createElement(SideBarOption, { menuOption: menuOption, onSelectedOption: (...args) => {
                    setSettingsToggle((p) => !p);
                    props.onSelectedOption(...args);
                }, chip: menuOption.chip })),
        React.createElement(Popover.Content, { offset: isFullScreen ? 32 : 12 }, menuOption.settingsParams
            ? React.createElement(SettingsMenuContent, { isHeaderHidden: isHeaderHidden, settingsParams: menuOption.settingsParams, onCloseSettings: () => setSettingsToggle(false) })
            : React.createElement(React.Fragment, null))));
};
//# sourceMappingURL=SettingsMenu.js.map